import React from 'react';
import styled from 'styled-components';
import {BgImage} from '../../images/BgImage';

const DetailBackground = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    background-color: ${(p) => p.theme.palette.common.black};

    .background-image {
        height: 100%;
        width: 100%;
        position: absolute;
        filter: blur(30px);
        transform: translate3d(0, 0, 0);
        opacity: 0.5;
    }
`;

const Headline = styled.h1`
    color: ${(p) => p.theme.palette.neutral.silver};
    font-size: 150px;
    line-height: 140px;
    font-family: ${(p) => p.theme.ue.fonts.brutal.extralight};
    position: absolute;
    z-index: 1;
    font-weight: 200;
    text-align: center;
    margin: 40px auto;
    left: 0;
    right: 0;
    opacity: 0.5;
`;

interface CreatorFeedDetailBackgroundProps {
    title?: string;
    imageSrc?: string;
}

export const CreatorFeedDetailBackground = ({
    title,
    imageSrc
}: CreatorFeedDetailBackgroundProps): JSX.Element => {
    return (
        <DetailBackground>
            {title && <Headline>{title}</Headline>}
            {imageSrc && <BgImage img={imageSrc} width={800} />}
        </DetailBackground>
    );
};
